var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"委托方信息"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.detailInfo,"option":_vm.detailConfig,"el-attrs":{
          size: 'medium',
          labelStyle: {
            whiteSpace: 'nowrap'
          }
        }}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }